import React from 'react';
import { CreditHistory } from "pages/licence-checking/shared/credit-history/CreditHistory";

export function LicenceCheckingCreditHistory(){
    return (
        <CreditHistory />
    )
}